import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Padding } from '../UI/StyledComponents'
import TextInput from '../UI/TextInput'
import Pixabay from '../../libs/pixabay'
import UnsplashApi from '../../libs/unsplash'
import InfiniteScroll from 'react-infinite-scroller'
import _ from 'lodash'
import axios from 'axios'
import Loader from '../UI/Loader'
import UploadAvatar from '../UI/UploadAvatar'
import { unsplashConfig } from '../../config'
import { NotificationManager } from 'react-notifications'

export default class ImgBankPhotoSelection extends Component {
  static propTypes = {
    t: PropTypes.func,
    maxCanBeSelected: PropTypes.number,
    onSave: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      key: 0,
      images: [],
      hasMore: false,
      query: 'places',
      initialLoad: true,
      pageStart: 2,
      maxCanBeSelected: this.props.maxCanBeSelected || 1,
      selectedImg: [],
      showLoader: false,
      uploadedImg: null,
      manualSelected: false,
      bankSelected: false,
      unsplashSearch: true
    }
    this.Unsplash = new UnsplashApi()
    this.Pixabay = new Pixabay()
  }

  componentDidMount() {
    this.getRandomUnsplashImage()
  }

  getRandomUnsplashImage() {
    let images = []
    this.setState({ hasMore: false, showLoader: true }, () => {
      try {
        this.Unsplash.getRandomUnsplashPhotos(this.state.query)
          .then((result, reject) => {
            if (!result || result.errors) {
              this.getRandomPixabayImage(2)
            } else {
              result.map(el => {
                const downloadLink = el.links.download_location + `?client_id=${unsplashConfig.appId}`
                const downloadImage = el.urls.regular

                images.push({
                  url: el.urls.thumb,
                  id: el.id,
                  name: el.id,
                  selected: false,
                  downloadLink: downloadLink,
                  downloadImage: downloadImage,
                  userData: el.user
                })
              })
              this.setState({ images: images, hasMore: true, showLoader: false, selectedImg: [], unsplashSearch: false })
            }
          })
          .catch(e => {
            this.getRandomPixabayImage(2)
            NotificationManager.error(e, 'Error', 5000)
          })
      } catch (e) {NotificationManager.error(e, 'Error', 5000)}
    })
  }

  getRandomPixabayImage(page) {
    let images = []
    this.setState({ hasMore: false, showLoader: true }, () => {
      this.Pixabay.getImages(this.state.query, page - 1, true)
        .then(result => {
          if (!result || result.error) {
            this.setState({ showLoader: false, hasMore: false })
            return
          }
          result.map(el => {
            const name = el.webformatURL.split('/').pop()
            images.push({ url: el.webformatURL, id: el.id, name: name, downloadImage: el.webformatURL, selected: false })
          })
          this.setState({
            images: [...this.state.images, ...images],
            hasMore: true,
            showLoader: false,
            selectedImg: [],
            unsplashSearch: true
          })
        })
        .catch(e => {NotificationManager.error(e, 'Error', 5000)})
    })
  }

  loadMoreFunc(page) {
    this.setState({ hasMore: false }, () => {
      let images = []
      console.log(this.state.unsplashSearch)
      if (this.state.unsplashSearch) {
        this.Unsplash.getRandomUnsplashPhotos(this.state.query)
          .then((result, reject) => {
            console.log(reject)
            if (!result || result.errors) {
              this.getRandomPixabayImage(page)
            } else {
              result.map(el => {
                const downloadLink = el.links.download_location + `?client_id=${unsplashConfig.appId}`

                images.push({
                  url: el.urls.thumb,
                  id: el.id,
                  name: el.id,
                  selected: false,
                  downloadLink: downloadLink,
                  userData: el.user
                })
              })
              this.setState({ images: [...this.state.images, ...images], hasMore: true, unsplashSearch: false })
            }
          })
          .catch(e => {
            this.getRandomPixabayImage(page)
            NotificationManager.error(e, 'Error', 5000)
          })
      } else {
        this.getRandomPixabayImage(page)
      }
    })
  }

  blobToFile(theBlob, fileName) {
    if (fileName && !fileName.toLowerCase().endsWith('.jpg')) {
      fileName = fileName + '.jpg'
    }
    var file = new File([theBlob], fileName)
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    //let theTime = new Date();
    //theBlob.lastModifiedDate = theTime;
    //theBlob.lastModified = theTime.getTime();
    //theBlob.name = fileName;
    return file
  }

  loadImageFromNetWork(name) {
    let photos = [...this.state.selectedImg]
    this.setState({ showLoader: true }, () => {
      photos.map((el, i) => {
        if (el.downloadLink) {
          // Send a mark to the download image - Unsplash request
          axios
            .get(el.downloadLink)
            .then(resp => {
              // Nothing more
            })
            .catch(function(error) {
              if (error.response) {
                console.log('Download link error')
                console.log(error.response.data)
                console.log(error.response.status)
                console.log(error.response.headers)
              } else if (error.request) {
                console.log(error.request)
              } else {
                console.log('Error', error.message)
              }
              console.log(error.config)
              NotificationManager.error(error.response.data, 'Error', 5000)
            })
        }
        // Actually download the image
        axios
          .get(el.downloadImage, { responseType: 'blob' })
          .then(resp => {
            const File = this.blobToFile(resp.data, el.name)
            this.setState({ loadedImgs: [File], showLoader: false }, () => {
              this.props.onSave(this.state.loadedImgs)
            })
          })
          .catch(function(error) {
            if (error.response) {
              console.log(error.response.data)
              console.log(error.response.status)
              console.log(error.response.headers)
            } else if (error.request) {
              console.log(error.request)
            } else {
              console.log('Error', error.message)
            }
            console.log(error.config)
            NotificationManager.error(error.response.data, 'Error', 5000)
          })
      })
    })
    //for multiple upload need add multiple load and return array of imgs
  }

  _handleImageChange(e) {
    e.preventDefault()
    let reader = new FileReader()
    let file = e.target.files[0]

    reader.onloadend = el => {
      if (file) {
        this.setState(
          {
            loadedImgs: [file],
            selectedImg: [],
            uploadedImg: el.target.result,
            manualSelected: true,
            bankSelected: false
          },
          () => {}
        )
      }
    }
    reader.readAsDataURL(file)
  }

  saveImages = () => {
    if (this.state.manualSelected) {
      this.props.onSave(this.state.loadedImgs)
    } else if (this.state.bankSelected) {
      this.loadImageFromNetWork()
    }
  }

  render() {
    const { t } = this.props
    const _handleKeyPress = (e, query) => {
      if (e.key === 'Enter') {
        this.setState({ key: this.state.key + 1, images: [], query: query }, () => {
          this.getRandomUnsplashImage(query)
        })
      }
    }

    return (
      <Padding size="24px">
        <div className="create-poi ">
          <h1>{t('title')}</h1>
          <hr />
          <label className="steps-screen__form-input-label">{t('search_help')}</label>
          <div className="gallery_input">
            <TextInput
              id="search"
              placeholder={t('input_placeholder')}
              inputWrapperClass="gallery_wrapper"
              onBlurExternal={e => {
                this.setState({ query: e.target.value ? e.target.value : 'places' })
              }}
              onKeyPress={e => {
                _handleKeyPress(e, e.target.value)
              }}
            />
            <button
              className="btn btn-danger"
              onClick={() => {
                this.setState({ key: this.state.key + 1, images: [] }, () => {
                  this.getRandomUnsplashImage(this.state.query)
                })
              }}
            >
              <i className="fa fa-search fa-2x" aria-hidden="true">
                {' '}
              </i>
            </button>
          </div>
        </div>

        <div className="gallery_scroll">
          <div className="gallery__result gallery_scroll_body" key={this.state.key}>
            <InfiniteScroll
              pageStart={this.state.pageStart}
              loadMore={e => {
                this.loadMoreFunc(e)
              }}
              hasMore={this.state.hasMore}
              useWindow={false}
              initialLoad={this.state.initLoad}
              threshold={50}
            >
              <div className={this.state.manualSelected ? 'gallery__upload_static gallery_selected' : 'gallery__upload_static'}>
                <UploadAvatar
                  id="manualImg"
                  customClassWrapper="gallery_textFa"
                  onFileChange={e => {
                    this._handleImageChange(e)
                  }}
                  initialPhoto={this.state.uploadedImg}
                  disabled={this.state.bankSelected}
                  customDiv={[
                    <span key="manualUpload">
                      <label htmlFor="file">
                        <i className="fa fa-picture-o gallery_fa" aria-hidden="true">
                          {' '}
                        </i>
                        <br />Upload Picture
                      </label>
                    </span>
                  ]}
                />
                <div className="image-dimension">200x133</div>
              </div>
              {this.state.images.map((el, i) => {
                const spanStyle = {
                  backgroundImage: 'url(' + el.url + ')'
                }

                return (
                  <div
                    key={i}
                    className={el.selected ? 'gallery__upload gallery_selected' : 'gallery__upload'}
                    onClick={() => {
                      if (el.selected !== true) {
                        //For multiselection you need comment this filter,  fix setState and add loop to load function
                        const SelectedImg = _.filter(this.state.images, function(currentObject) {
                          if (currentObject.selected === true) {
                            currentObject.selected = false
                          }
                          return currentObject
                        })
                        el.selected = true
                        this.setState(({ images, selectedImg }) => ({
                          images: [...SelectedImg, ...el],
                          selectedImg: [...this.state.selectedImg, el],
                          bankSelected: true,
                          manualSelected: false
                        }))
                      } else if (el.selected === true) {
                        el.selected = false
                        const SelectedImg = _.filter(this.state.selectedImg, function(currentObject) {
                          return currentObject.id !== el.id
                        })

                        this.setState(({ images, selectedImg }) => ({
                          images: [...this.state.images, ...el],
                          selectedImg: [...SelectedImg],
                          bankSelected: false
                        }))
                      }
                    }}
                  >
                    {el.userData ? (
                      <span className="gallery_background_box" style={spanStyle}>
                        <a
                          className="gallery_attribution"
                          href={el.userData.links.html + `?utm_source=${unsplashConfig.name}&utm_medium=referral`}
                          target="_blank"
                          title=""
                        >
                          {el.userData.name}
                        </a>
                      </span>
                    ) : (
                      <span className="gallery_background_box" style={spanStyle}>
                        <a className="gallery_attribution" href="https://pixabay.com/" target="_blank" title="">
                          @Pixabay
                        </a>
                      </span>
                    )}
                  </div>
                )
              })}
            </InfiniteScroll>
          </div>
        </div>

        <button
          className="btn create-poi__submit-btn"
          onClick={() => {
            this.saveImages()
          }}
        >
          {t('select')}
        </button>

        <Loader showLoader={this.state.showLoader} />
      </Padding>
    )
  }
}



// WEBPACK FOOTER //
// src/components/ImgBankPhotoSelection/index.js